import { Container } from "../../../reducers/componentSearch";
import settings from "../../../constants/settings";
import useSWRFetcher, { SWRFetchError } from "../commonly-stored/fetcher";
import useSWR from "swr";
import { useEffect, useState } from "react";

export default function useContainer(containerBarcode: string | null) {
  const fetcher = useSWRFetcher<Container>();
  const [containerNotFound, setContainerNotFound] = useState(false);
  const {
    data: container,
    error,
    mutate,
  } = useSWR<Container, SWRFetchError>(
    containerBarcode !== null
      ? `${settings.api_url}/inventory/containers/${containerBarcode}`
      : null,
    fetcher,
    {
      shouldRetryOnError: (error: SWRFetchError) => {
        return error.status != 404;
      },
    },
  );

  useEffect(() => {
    setContainerNotFound(error?.status === 404);
  }, [error?.status]);

  return {
    container: container || null,
    refreshContainer: () => void mutate(),
    containerNotFound,
  };
}
